var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.closeDropdown,
          expression: "closeDropdown",
        },
      ],
      staticClass: "dropdown-container",
      on: {
        click: function ($event) {
          return $event.stopPropagation()
        },
      },
    },
    [
      _c("div", { staticClass: "dropdown-button" }, [
        _c(
          "div",
          { staticStyle: { display: "inline" } },
          [
            _vm.label !== null
              ? [
                  _c(
                    "div",
                    { staticClass: "dropdown-label" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-label-text",
                          on: { click: _vm.selectDropdown },
                        },
                        [_vm._v(_vm._s(_vm.label))]
                      ),
                      _vm._v(" "),
                      _vm.labelLoading === true
                        ? _c("fa", {
                            staticClass: "chevron",
                            attrs: { icon: "spinner", spin: "" },
                          })
                        : _vm.disabled === false
                        ? _c("fa", {
                            staticClass: "chevron",
                            attrs: { icon: "chevron-down" },
                            on: { click: _vm.selectDropdown },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              : _c(
                  "div",
                  { on: { click: _vm.selectDropdown } },
                  [_vm._t("dropdownToggler")],
                  2
                ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.show === true
          ? _c(
              "div",
              {
                staticClass: "dropdown-outside-toggle",
                style: _vm.dropdownStyle,
              },
              [
                _vm.heading
                  ? _c(
                      "div",
                      {
                        staticClass: "dropdown-title",
                        on: {
                          click: function ($event) {
                            return $event.stopPropagation()
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.heading))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("dropdownContent"),
              ],
              2
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }